/**
 * @component BizSignComponent
 * @title 전자서명 팝업
 * @description
 *
 *  PUBLISH ID [
 *  - LGNMTH005-04FP : 전자서명 인증서 비밀번호 입력 팝업
 *  - COMSIG000-01FP :
 *  - COMSIG000-01MS :
 *  - COMSIG000-12FP :
 *  - COMSIG000-12MS :
 * ]
 * @properties
 *  Props {
 *  }
 * @linked_menu
 * @author 2034263
 * @history
 *   - [2025-09-30] 초기 작성
 */

// 외부 라이브러리
import { memo, useState } from 'react';

import { Envs, useEnvContext } from 'scbk-services';

// UI 라이브러리
import { DialogWrapper } from 'scbk-ui-web';

// 업무 모듈

import { SignVerifyType } from '../enums';
import { useSign } from '../hooks';
import { JointCertBizSignDialog } from './JointCertBizSignDialog';
import { SignTypeSelectorDialog } from './SignTypeSelectorDialog';

export const BizSignComponent: React.FC<ReturnType<typeof useSign>> = memo(
  (props) => {
    const currentEnv = useEnvContext().getEnv(); // 환경변수

    // state
    const [runSignFlag, setRunSignFlag] = useState<boolean>(
      currentEnv === Envs.LOCAL || currentEnv === Envs.DEV ? false : true,
    );

    return (
      <>
        {runSignFlag && props.signCtx.current?.verifyType === null && (
          <SignTypeSelectorDialog {...props} />
        )}

        {runSignFlag && props.signCtx.current?.verifyType === SignVerifyType.JOINT_CERT && (
          <JointCertBizSignDialog {...props} />
        )}

        {/* 개발환경 전자서명 스킵 */}
        {!runSignFlag && (
          <DialogWrapper
            title={'개발환경 전자서명 실행 여부 확인'}
            open={props.signPopup.isOpen}
            setOpen={props.signPopup.setOpen}
            isFull={false}
            onClose={() => {
              props.onCancelSign();
            }}
            footer={[
              {
                type: 'secondary',
                title: '실행',
                handler: () => {
                  setRunSignFlag(true);

                  if (props.signCtx.current?.verifyType) {
                    props.selectSignType(props.signCtx.current.verifyType);
                  }
                },
                hasClose: false,
              },
              {
                type: 'primary',
                title: '스킵',
                handler: () => {
                  props.onSkipSign();
                },
                hasClose: false,
              },
            ]}
          >
            <></>
          </DialogWrapper>
        )}
        {/* 개발환경 전자서명 스킵 */}
      </>
    );
  },
  (prev, next) => {
    return prev.signCtx.current != next.signCtx.current;
  },
);
